import routes from './begin.routes';

export const beginModule = {
    routes
};